<template>
  <v-dialog v-model="model" width="450">
    <v-card>
      <v-card-title class="text-h6 text-primary">
        {{ $t(titleKey) }}
      </v-card-title>
      <v-card-text>
        <div v-html="message"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onCancel">{{ $t(cancelKey) }}</v-btn>
        <v-btn color="secondary" text @click="onConfirm">{{
          $t(confirmKey)
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  titleKey: { type: String, default: "strings.confirm-title" },
  // message may contain HTML; allow either a raw string or a translation key
  message: { type: String, default: "" },
  cancelKey: { type: String, default: "labels.cancel" },
  confirmKey: { type: String, default: "labels.delete" },
});
const emit = defineEmits(["update:modelValue", "confirm", "cancel"]);
const model = computed({
  get: () => props.modelValue,
  set: (v) => emit("update:modelValue", v),
});

function onConfirm() {
  emit("confirm");
  model.value = false;
}
function onCancel() {
  emit("cancel");
  model.value = false;
}
</script>

<style scoped></style>
